import { CSSProperties } from 'react';

export function BrandHero({
  src = '/images/teebox-exterior.jpg',
  alt = 'Tee Box',
  title = 'Train with purpose',
  subtitle = 'Grow with consistency.',
  heightClass = 'h-56 sm:h-72',
  heightStyle,
  fullBleed = false,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
}: {
  src?: string;
  alt?: string;
  title?: string;
  subtitle?: string;
  heightClass?: string;
  heightStyle?: CSSProperties;
  fullBleed?: boolean;
  primaryHref?: string;
  primaryLabel?: string;
  secondaryHref?: string;
  secondaryLabel?: string;
}) {
  return (
    <div
      className={`relative ${heightClass} ${fullBleed ? '' : 'rounded-2xl border border-gray-100'} overflow-hidden`}
      style={heightStyle}
    >
      <img
        src={src}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.08),rgba(0,0,0,0.55))]" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 p-6 text-white">
        <div className="max-w-md mx-auto text-center">
          <h1 className="text-2xl font-bold mb-1">{title}</h1>
          <p className="text-white/85 text-sm mb-4">{subtitle}</p>
          {(primaryHref || secondaryHref) && (
            <div className="flex gap-2 justify-center">
              {primaryHref && primaryLabel && (
                <a
                  href={primaryHref}
                  className="px-4 py-2 rounded-lg bg-[#bd9734] text-white text-sm font-medium shadow-sm"
                >
                  {primaryLabel}
                </a>
              )}
              {secondaryHref && secondaryLabel && (
                <a
                  href={secondaryHref}
                  className="px-4 py-2 rounded-lg border border-[#bd9734] text-[#bd9734] bg-white/10 backdrop-blur text-sm font-medium"
                >
                  {secondaryLabel}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
